// extracted by mini-css-extract-plugin
export default {"stack":"ParallelRideStep_stack__VYBVo"};